/* import __COLOCATED_TEMPLATE__ from './default-attribute-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();